import { useEffect } from 'react';
import { useNavigate, useSearch } from '@tanstack/react-router';
import { useCalendarHeaderContext } from '../../../../../context/calendar-header-context';
import { useCalendarStore } from '../../../../../stores';
import { CALENDAR_TRACKING_IDS } from '../../../../../trackingIds/calendar-tracking-ids';
import { getDateString } from '../../../../../utils/date-helpers';
import { CalendarDateSelectorUI } from './calendar-date-selector-ui';

const trackingIds = {
  todayButton: CALENDAR_TRACKING_IDS.headerBar.dateNavigationTodayButton,
  nextButton: CALENDAR_TRACKING_IDS.headerBar.dateNavigationNextDayButton,
  prevButton: CALENDAR_TRACKING_IDS.headerBar.dateNavigationPreviousDayButton,
  dateInput: CALENDAR_TRACKING_IDS.headerBar.dateNavigationDateInput,
  datePicker: CALENDAR_TRACKING_IDS.headerBar.dateNavigationDatePicker,
};

export const CalendarDateSelector = () => {
  const navigate = useNavigate();
  const { calendarDate, setCalendarDate } = useCalendarStore(['calendarDate', 'setCalendarDate']);
  const { calendarTodayDate } = useCalendarHeaderContext();
  const { currentDate } = useSearch({ strict: false }) as {
    currentDate?: string;
  };

  // Initialize calendar date with location's timezone-adjusted today date, when not set
  useEffect(() => {
    if (!calendarDate) {
      const calendarDateParamDate = getDateString(currentDate);
      const date = calendarDateParamDate || calendarTodayDate;
      if (date) setCalendarDate(date);
    }
  }, [calendarDate, currentDate, calendarTodayDate, setCalendarDate, navigate]);

  return (
    <CalendarDateSelectorUI
      selectedDate={calendarDate}
      todayDate={calendarTodayDate}
      trackingIds={trackingIds}
      onSelectedDateChange={setCalendarDate}
    />
  );
};
